'use client';

import { DealershipAttrs } from '@core/Entities/Dealership/Dealership.entity';
import { Locale } from '@core/Entities/Locale/Locale.entity';
import Button from '@gds/Button/Button';
import { Email } from '@gds/Icons/Paths/Email';
import { useIsExperimentEnabled } from '@growthBookExperimentation/Hooks/useIsExperimetEnabled';

import { LocationAttrs } from 'Components/SearchWidget/Search.entity';

import { PlpFiltersMessagesProps } from '../Filters/FilterPanel.entity';

import { useSavedSearchForm } from './UseSavedSearchForm';

import styles from './SavedSearchForm.module.css';

interface SavedSearchFilterCtaProps {
  locale: Locale;
  strings: PlpFiltersMessagesProps;
  locationAttrs?: LocationAttrs;
  dealerAttrs?: DealershipAttrs;
}

export const SavedSearchFilterCta = ({
  locale,
  strings,
  locationAttrs,
  dealerAttrs,
}: SavedSearchFilterCtaProps) => {
  const isButtonPrimary = useIsExperimentEnabled('saved-search-cta-visibility', '1');
  const { openForm, canUseSavedSearch } = useSavedSearchForm({
    locale,
    strings,
    locationAttrs,
    dealerAttrs,
  });

  return (
    <div className={`${styles.filterCtaWrapper} ${!canUseSavedSearch ? styles.noPadding : ''}`}>
      {canUseSavedSearch && (
        <Button
          {...(isButtonPrimary && { ['data-desktop-only']: true })}
          leftIcon={<Email />}
          {...(isButtonPrimary && { color: 'primary' })}
          {...(!isButtonPrimary && { variant: 'outlined' })}
          onClick={openForm}
          fullWidth
        >
          {strings.createAlert}
        </Button>
      )}
    </div>
  );
};

SavedSearchFilterCta.displayName = 'SavedSearchFilterCta';
